module.exports = __webpack_public_path__ + "img/6.347a1e3a.jpg";